// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"618d02f9","453":"41811d64","455":"ccfc9290"}[chunkId] + ".chunk.js";
};